const regex = {
  declarationPlace: new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/),
  serialandpartNumber: new RegExp(/^(0|[1-9][0-9]{0,3})$/),
  noOfApplications: new RegExp(/^(0|[1-9]\d{0,2})$/),
  EPIC: new RegExp(
    /^([a-zA-Z]){3}([0-9]){7}?$|^[a-zA-Z0-9]+(?:[\/\\][a-zA-Z0-9]+)*$/
  ),
  number: new RegExp("^[0-9]+$"),
  aadhaar: new RegExp("^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$"),
  aadhaar2: new RegExp(/^[2-9]{1}[0-9]{11}$/),
  textinput: new RegExp(/^[A-Za-z]+$/),
  passwordupper: new RegExp(/^(?=.*[A-Z])/),
  passworddigit: new RegExp(/^(?=.*\d)/),
  passwordspecial: new RegExp(/^[^*|\":~+=%/:<>:^<>?[\]{}`\\()';&$]+$/),
  passwordmin: new RegExp(/^[A-Za-z\d\W_]{8,25}$/),
  textinputwithspace: new RegExp(/^[\s\dA-Za-z]+$/),
  // firstName: new RegExp(/^[\sA-Za-z]+$/),
  firstName: new RegExp(/^(([\sA-Za-z])\2?(?!\2))+$/),
  textArea: new RegExp(/^[\sA-Za-z]+$/),
  placeOfIssue: new RegExp(/^[a-zA-Z0-9]+(?:[\s-][a-zA-Z0-9]+)*$/),
  pancard: new RegExp(/^([a-zA-Z]{3}[pP]{1}[a-zA-Z]{1}[\d]{4}[A-Za-z]{1})?$/),
  email: new RegExp(
    /\b(^['_A-Za-z0-9-]+(\.['_A-Za-z0-9-]+)*@([A-Za-z0-9-])+(\.[A-Za-z0-9-]+)*((\.[A-Za-z0-9]{2,3})|(\.[A-Za-z0-9]{2,3}\.[A-Za-z0-9]{2,3}))$)\b/
  ),
  emailCEODEO: new RegExp(/^[^*|\":~+=%/:<>!:#^<>?[\]{}`\\();@&$]+@([a-z]+\.)?(gov\.in|nic\.in)$/i),
  otp: new RegExp(/^[0-9]{6,6}$/),
  category: new RegExp(/\b(?:SC|GEN|ST)\b/g),
  nameLength: new RegExp(/^[\sA-Za-z]{1,50}$/),
  // voterID: new RegExp(/^([a-zA-Z]){3}([0-9]){7}?$/),
  // passport: new RegExp(/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/ig),
  // voterID: new RegExp(/^([a-zA-Z]){3}([0-9]){7}?$/),
  // voterID: new RegExp(/^[A-Z][A-Z][A-Z][1-9]\d\s?\d{4}[1-9]$/ig),
  // voterID: new RegExp(/^([A-Z]){3}([0-9]){7}$/),
  voterID: new RegExp(/^([A-Z]){3}(?!0{7})([0-9]){7}$/),
  nospecial: new RegExp(/^[^*|\":~+,=%/:<>!:#^<>?.[\]{}`\\()';@&$]+$/),
  nospecialReason: new RegExp(/^[^*|\":~+=%/:<>!:#^<>?[\]{}`\\();@&$]+$/),
  zipcode: new RegExp(/^[1-9][0-9]{5}$/),
  pincode: new RegExp("^[1-9]{1}[0-9]{2}\\s{0,1}[0-9]{3}$"),
  // passport: new RegExp(/^[A-Z]{1}[0-9]{7}$/),
  passport: new RegExp(/^[A-Z][1-9]\d\s?\d{4}[1-9]$/),
  country: new RegExp(/^[\sA-Za-z\.',\-()]{0,35}$/),
  reason: new RegExp(/^[\s\dA-Za-z\-\.,':/()&]{0,70}$/),
  birthplace: new RegExp(/^([A-Za-z0-9'\s\-()&,./]{0,25})?$/),
  address: new RegExp(
    /^(?![0-9]*$)(?![-]*$)(?![']*$)(?![.]*$)(?![/]*$)(?![,]*$)[\s\da-zA-Z0-9\-.,'/]+$/
  ),
  noSpecialAddress: new RegExp(/^[^*|\:<>!:#^<>?[\]{}`\\;@$]+$/),
  // address: new RegExp(/^(?![0-9]*$)(?![-]*$)(?![,]*$)[\sa-zA-Z0-9\-,]+$/),
  houseNo: new RegExp(
    /^(?![-]*$)(?![']*$)(?![.]*$)(?![/]*$)(?![,]*$)[\sa-zA-Z0-9\-.,'/]+$/
  ),
  noSpecialhouseNo: new RegExp(/^[^*|\:<>!:#^<>?[\]{}`\\();@&$]+$/),
  declareplace: new RegExp(/^[\s\dA-Za-z\-\.,'/()&]{0,30}$/),
  villageTown: new RegExp(/^[\s\dA-Za-z\-\.,'/()&]{0,32}$/),
  mobile: new RegExp(/^[6-9]\d{9}$/),
  name: new RegExp(/^([A-Za-z]{1}[A-Za-z'\s]{0,44})?$/),
  nameAddress: new RegExp(/^[A-Za-z]{1}[\s\dA-Za-z\-\._,':;/()&]{0,105}$/),
  phnumbr: new RegExp(/^\+?^[6-9]\d{9}$/),
  otherSpecify: new RegExp(/^[\s\dA-Za-z\-\.,':/()]{0,46}$/),
  visibleMark: new RegExp(/^[a-zA-Z0-9.\s]{0,36}$/),
  passportFileno: new RegExp(/^([\s\dA-Za-z,:;'/~!*.\-\\]{4,15})?$/),
  parentsNation: new RegExp(/^([A-Za-z]{1}[A-Za-z'\s]{0,15})?$/),
  hnoStreetVisibleMarkEmpGovt2: new RegExp(/^[\s\dA-Za-z\-\.,:;/()&]{0,48}$/),
  policestPO: new RegExp(/^[\s\dA-Za-z\-\.,':/()]{0,50}$/),
  file: new RegExp(/^(([\dA-Za-z,:;'/~!*.\-\\]{6,15}))?$/),
  passApplNotIssuedPO: new RegExp(/^[\s\dA-Za-z\-\.,':/()]{0,25}$/),
  casenoLawsec: new RegExp(/^[\s\dA-Za-z\-\.,':/()&]{0,50}$/),
  ecno: new RegExp(/^([\s\dA-Za-z]{4,20})?$/),
  // visaNo: new RegExp("^4[0-9]{14}$"),
  visaNo: new RegExp(/^[0-9a-zA-Z]+$/),
  // foreignZipcode: new RegExp(/^\d{5}(?:[- ]?\d{4})?$/),
  foreignZipcode: new RegExp(/^[A-Za-z0-9 ]+$/),
  namevalidation: new RegExp(/^[a-zA-Z]+([\.]{0,1}[\s]{0,1}[a-zA-Z]+)*$/),
  // date: new RegExp(
  //   /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,   ///^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;/^(31[ \/ ](0[13578]|1[02])[ \/ ](18|19|20)[0-9]{2})|((29|30)[\/](01|0[3-9]|1[1-2])[\/](18|19|20)[0-9]{2})|((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[0-2])[\/](18|19|20)[0-9]{2})|(29[\/](02)[\/](((18|19|20)(04|08|[2468][048]|[13579][26]))|2000))$/; ///^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](18|19|20)\d\d$/

  // ),
  nospeclchar: new RegExp(/^[\s\dA-Za-z\-+\._,?@$!#*%':/=()&]{0,1000}$/),
  amount: new RegExp(/^(?!$)\d{0,10}(?:\.\d{1,2})?$/),
  hnoSt3: new RegExp(/^[\s\dA-Za-z\-\.,:;/()&']{0,48}$/),
  passPlOfissue: new RegExp(/^[\s\dA-Za-z\-\.,'/()&:;]{0,32}$/),
  casenols1: new RegExp(/^[\s\dA-Za-z\-\.,':/()&]{0,50}$/),
  otherspurpOfvisit: new RegExp(/^[A-Za-z]{0,20}$/),
  otherspecEyesandHair: new RegExp(/^[A-Za-z]{0,15}$/),
  icfile: new RegExp(/^(([\s\dA-Za-z,:;()_#'/!*.\-\\]{6,50}))?$/),
  rcno: new RegExp(/^(([\s\dA-Za-z,:;()'/!*.\-\\]{6,50}))?$/),
  selfdeclRemark: new RegExp(/^[\sA-Za-z\-\.,'/()&]{0,250}$/),
  remarks: new RegExp(/^[a-zA-z\-\.,'/()&]+([\s][a-zA-Z\-\.,'/()&]+)*$/),
  length250: new RegExp(/^[\s\S]{0,250}$/),
  length50: new RegExp(/^[\s\S]{0,50}$/),
  postOffice: new RegExp(
    /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]*)?\b/i
  ),
  location: new RegExp(/^([A-Za-z0-9'\s\-()&,./]{0,100})?$/),
  landline: new RegExp(/^[0]\d{4,5}([-]*)\d{5}$/),
  maxminNumber: new RegExp(/^[1-9][0-9]?$|^100$/),
  passwordSpace: new RegExp(/^(?!.* )/),
  NotAnEro: new RegExp(/^(?!ero|aero|ERO|AERO).*/i),
};

var d = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];

// permutation table p
var p = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

// inverse table inv
var inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

function invArray(array) {
  if (Object.prototype.toString.call(array) === "[object Number]") {
    array = String(array);
  }
  if (Object.prototype.toString.call(array) === "[object String]") {
    array = array.split("").map(Number);
  }
  return array.reverse();
}

export class Validators {
  static email(value, message) {
    if (value) {
      const result = regex.email.test(value);
      if (!result) return { error: true, message };
    }
  }
  static emailCEODEO(value, message) {
    if (value) {
      const result = regex.emailCEODEO.test(value);
      if (!result) return { error: true, message };
    }
  }

  static declarationPlace(value, message) {
    if (value) {
      const result = regex.declarationPlace.test(value);
      if (!result) return { error: true, message };
    }
  }

  static passwordupper(value, message) {
    if (value) {
      const result = regex.passwordupper.test(value);
      if (!result) return { error: true, message };
    }
  }

  static passworddigit(value, message) {
    if (value) {
      const result = regex.passworddigit.test(value);
      if (!result) return { error: true, message };
    }
  }

  static passwordspecial(value, message) {
    if (value) {
      const result = regex.passwordspecial.test(value);
      if (!result) return { error: true, message };
    }
  }

  static remarks(value, message) {
    if (value) {
      const result = regex.remarks.test(value);
      if (!result) return { error: true, message };
    }
  }

  static length250(value, message) {
    if (value) {
      const result = regex.length250.test(value);
      if (!result) return { error: true, message };
    }
  }

  static length50(value, message) {
    if (value) {
      const result = regex.length50.test(value);
      if (!result) return { error: true, message };
    }
  }
  
  static passwordmin(value, message) {
    if (value) {
      const result = regex.passwordmin.test(value);
      if (!result) return { error: true, message };
    }
  }

  static serialandpartNumber(value, message) {
    if (value) {
      const result = regex.serialandpartNumber.test(value);
      if (!result) return { error: true, message };
    }
  }

  static noOfApplications(value, message) {
    if (value) {
      const result = regex.noOfApplications.test(value);
      if (!result) return { error: true, message };
    }
  }

  static EPIC(value, message) {
    if (value) {
      const result = regex.EPIC.test(value);
      if (!result) return { error: true, message };
    }
  }
  static country(value, message) {
    if (value) {
      const result = regex.country.test(value);
      if (!result) return { error: true, message };
    }
  }
  static reason(value, message) {
    if (value) {
      const result = regex.reason.test(value);
      if (!result) return { error: true, message };
    }
  }
  static address(value, message) {
    if (value) {
      const result = regex.address.test(value);
      if (!result) return { error: true, message };
    }
  }
  static noSpecialAddress(value, message) {
    if (value) {
      const result = regex.noSpecialAddress.test(value);
      if (!result) return { error: true, message };
    }
  }
  static nospecialReason(value, message) {
    if (value) {
      const result = regex.nospecialReason.test(value);
      if (!result) return { error: true, message };
    }
  }
  static houseNo(value, message) {
    if (value) {
      const result = regex.houseNo.test(value);
      if (!result) return { error: true, message };
    }
  }
  static noSpecialhouseNo(value, message) {
    if (value) {
      const result = regex.noSpecialhouseNo.test(value);
      if (!result) return { error: true, message };
    }
  }
  static birthplace(value, message) {
    if (value) {
      const result = regex.birthplace.test(value);
      if (!result) return { error: true, message };
    }
  }

  static location(value, message) {
    if (value) {
      const result = regex.location.test(value);
      if (!result) return { error: true, message };
    }
  }

  static declareplace(value, message) {
    if (value) {
      const result = regex.declareplace.test(value);
      if (!result) return { error: true, message };
    }
  }

  static villageTown(value, message) {
    if (value) {
      const result = regex.villageTown.test(value);
      if (!result) return { error: true, message };
    }
  }
  static phnumbr(value, message) {
    if (value) {
      const result = regex.phnumbr.test(value);
      if (!result) return { error: true, message };
    }
  }

  static otherSpecify(value, message) {
    if (value) {
      const result = regex.otherSpecify.test(value);
      if (!result) return { error: true, message };
    }
  }

  static mobile(value, message) {
    if (value) {
      const result = regex.mobile.test(value);
      if (!result) return { error: true, message };
    }
  }

  static passwordSpace(value, message) {
    if (value) {
      const result = regex.passwordSpace.test(value);
      if (!result) return { error: true, message };
    }
  }

  static landline(value, message) {
    if (value) {
      const result = regex.landline.test(value);
      if (!result) return { error: true, message };
    }
  }
  // validates checksum
  static aadhaar2 = (array, message) => {
    const length = array ? array.toString().length : 0;
    if (length === 12) {
      var c = 0;
      var invertedArray = invArray(array);
      for (var i = 0; i < invertedArray.length; i++) {
        c = d[c][p[i % 8][invertedArray[i]]];
      }
      if (c === 0) {
        return false;
      }
    }
    return { error: true, message };
  };

  static mobRegEx(value, message) {
    if (value) {
      const result = regex.mobRegEx.test(value);
      if (!result) return { error: true, message };
    }
  }

  static OTPRegEx(value, message) {
    if (value) {
      const result = regex.otp.test(value);
      if (!result) return { error: true, message };
    }
  }

  static CatRegEx(value, message) {
    if (value) {
      const result = regex.category.test(value);
      if (!result) return { error: true, message };
    }
  }

  static nameLength(value, message) {
    if (value) {
      const result = regex.nameLength.test(value);
      if (!result) return { error: true, message };
    }
  }

  static visibleMark(value, message) {
    if (value) {
      const result = regex.visibleMark.test(value);
      if (!result) return { error: true, message };
    }
  }
  static passportFileno(value, message) {
    if (value) {
      const result = regex.passportFileno.test(value);
      if (!result) return { error: true, message };
    }
  }
  static parentsNation(value, message) {
    if (value) {
      const result = regex.parentsNation.test(value);
      if (!result) return { error: true, message };
    }
  }
  static hnoStreetVisibleMarkEmpGovt2(value, message) {
    if (value) {
      const result = regex.hnoStreetVisibleMarkEmpGovt2.test(value);
      if (!result) return { error: true, message };
    }
  }
  static policestPO(value, message) {
    if (value) {
      const result = regex.policestPO.test(value);
      if (!result) return { error: true, message };
    }
  }
  static file(value, message) {
    if (value) {
      const result = regex.file.test(value);
      if (!result) return { error: true, message };
    }
  }
  static passApplNotIssuedPO(value, message) {
    if (value) {
      const result = regex.passApplNotIssuedPO.test(value);
      if (!result) return { error: true, message };
    }
  }
  static casenoLawsec(value, message) {
    if (value) {
      const result = regex.casenoLawsec.test(value);
      if (!result) return { error: true, message };
    }
  }
  static ecno(value, message) {
    if (value) {
      const result = regex.ecno.test(value);
      if (!result) return { error: true, message };
    }
  }
  static nospeclchar(value, message) {
    if (value) {
      const result = regex.nospeclchar.test(value);
      if (!result) return { error: true, message };
    }
  }
  static amount(value, message) {
    if (value) {
      const result = regex.amount.test(value);
      if (!result) return { error: true, message };
    }
  }
  static hnoSt3(value, message) {
    if (value) {
      const result = regex.hnoSt3.test(value);
      if (!result) return { error: true, message };
    }
  }
  static passPlOfissue(value, message) {
    if (value) {
      const result = regex.passPlOfissue.test(value);
      if (!result) return { error: true, message };
    }
  }
  static casenols1(value, message) {
    if (value) {
      const result = regex.casenols1.test(value);
      if (!result) return { error: true, message };
    }
  }
  static otherspurpOfvisit(value, message) {
    if (value) {
      const result = regex.otherspurpOfvisit.test(value);
      if (!result) return { error: true, message };
    }
  }
  static otherspecEyesandHair(value, message) {
    if (value) {
      const result = regex.otherspecEyesandHair.test(value);
      if (!result) return { error: true, message };
    }
  }
  static icfile(value, message) {
    if (value) {
      const result = regex.icfile.test(value);
      if (!result) return { error: true, message };
    }
  }
  static rcno(value, message) {
    if (value) {
      const result = regex.rcno.test(value);
      if (!result) return { error: true, message };
    }
  }
  static selfdeclRemark(value, message) {
    if (value) {
      const result = regex.selfdeclRemark.test(value);
      if (!result) return { error: true, message };
    }
  }

  static required(value, message) {
    if (!value || !value.toString().trim().length) {
      return { error: true, message };
    }
    return false;
  }

  static number(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.number.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static textinput(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.textinput.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static firstName(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.firstName.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static textArea(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.textArea.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static placeOfIssue(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.placeOfIssue.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static name(value, message) {
    if (value) {
      const result = regex.name.test(value);
      if (!result) return { error: true, message };
    }
  }

  static nameAddress(value, message) {
    if (value) {
      const result = regex.nameAddress.test(value);
      if (!result) return { error: true, message };
    }
  }

  static aadhaar(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.aadhaar.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
  static aadhaar2(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.aadhaar2.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static pancard(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.pancard.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
  static voterID(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.voterID.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
  static nospecial(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.nospecial.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static NotAnEro(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.NotAnEro.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static zipcode(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.zipcode.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static pincode(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.pincode.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static visaNo(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.visaNo.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static foreignZipcode(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.foreignZipcode.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static passport(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.passport.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static postOffice(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.postOffice.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }

  static date(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.date.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
  static namevalidation(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.namevalidation.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
  static maxminNumber(value, message) {
    const length = value ? value.toString().length : 0;

    if (length > 0) {
      const result = regex.maxminNumber.test(value);
      if (!result) {
        return { error: true, message };
      }
    }
    return false;
  }
}

export const validateInput = (validators, value) => {
  if (validators && validators.length) {
    for (let i = 0; i < validators.length; i++) {
      const error = validators[i].check(value, validators[i].message);

      if (error) {
        return error;
      }
    }
  }
  return false;
};
